import { render, staticRenderFns } from "./urgenciaEvolucion.vue?vue&type=template&id=d418d374&scoped=true&"
import script from "./urgenciaEvolucion.vue?vue&type=script&lang=js&"
export * from "./urgenciaEvolucion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d418d374",
  null
  
)

export default component.exports